// extracted by mini-css-extract-plugin
module.exports = {"headerWithAnchor":"MacroheaderWithAnchor_headerWithAnchor__CQN8Q"};